import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Card, Button } from 'antd';
import { StoreContext } from '../store/index';
import { getDateFromTimestamp } from '../utils';
import ViewShiftModal from './viewShiftModal';
import { getColumnSearchProps } from '../tableUtils';
import './index.css';

const ShiftsTable = ({ shifts, isLoading }) => {
  const store = useContext(StoreContext);
  const {
    user: [user],
    sports: [sports],
  } = store;
  const navigate = useNavigate();

  const [showShiftModal, setShowShiftModal] = useState(false);
  const [shift, setShift] = useState(null);

  const onChange = (pagination, filters, sorter, extra) => {};

  const handleViewShift = id => {
    setShift(shifts.find(s => s.id === id));
    setShowShiftModal(true);
  };
  const onCloseViewShiftModal = () => {
    setShift(null);
    setShowShiftModal(false);
  };

  const columns = [
    {
      title: 'Fecha',
      dataIndex: 'startDate',
      key: 'id',
      sorter: (a, b) => b.startDate - a.startDate,
      render: startDate => getDateFromTimestamp(startDate),
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Direccion',
      dataIndex: 'address',
      key: 'id',
      ...getColumnSearchProps('address'),
      sorter: (a, b) => a.address.length - b.address.length,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Jugadores',
      dataIndex: 'totalPlayers',
      key: 'id',
      render: (totalPlayers, row) => `${row.actualPlayers}/${row.totalPlayers}`,
    },
    {
      title: 'Precio',
      dataIndex: 'price',
      key: 'id',
      ...getColumnSearchProps('price'),
      sorter: (a, b) => a.price.length - b.price.length,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Reservado',
      dataIndex: 'isReserved',
      key: 'id',
      width: '10%',
      render: isReserved => (isReserved ? 'Si' : 'No'),
    },
    {
      title: 'Completo',
      dataIndex: 'isClosed',
      key: 'id',
      render: isClosed => (isClosed ? 'Si' : 'No'),
    },
    {
      title: 'Publico',
      dataIndex: 'isPublic',
      key: 'id',
      render: isPublic => (isPublic ? 'Si' : 'No'),
    },
    {
      title: 'Complejo',
      dataIndex: 'placeName',
      key: 'id',
      ...getColumnSearchProps('placeName'),
      sorter: (a, b) => a.placeName.length - b.placeName.length,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Cancha',
      dataIndex: 'fieldName',
      key: 'id',
      ...getColumnSearchProps('fieldName'),
      sorter: (a, b) => a.fieldName.length - b.fieldName.length,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Acciones',
      dataIndex: 'id',
      key: 'id',
      fixed: 'right',
      render: id => <Button onClick={() => handleViewShift(id)}>Ver</Button>,
    },
  ];

  return (
    <Card className="card">
      {showShiftModal && (
        <ViewShiftModal
          shift={shift}
          setShift={setShift}
          onClose={onCloseViewShiftModal}
        />
      )}
      <Table
        loading={isLoading}
        columns={columns}
        dataSource={[...shifts]}
        onChange={onChange}
        scroll={{ x: 800 }}
      />
    </Card>
  );
};

export default ShiftsTable;
